import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { PageBrandCreditAccounts } from "@components/modules/brands/credit-accounts/PageBrandCreditAccounts";
import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { NavigationBrand } from "@src/components/widgets/AppSubNav/NavigationBrand";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Credit accounts`}
    navigation={<NavigationBrand id={id} variant="panel" />}
  >
    <DemoModule module={Modules.InvoicesCreditAccounts}>
      <PageBrandCreditAccounts />
    </DemoModule>
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/brands/credit-accounts")({
  component: RouteComponent,
});
